// Conformité — Pipeline Avances Installateurs (steppers horizontaux).
// NOTE : ce widget reste réservé aux rôles admin/commercial — pas aux
// installateurs externes (cf. catalog roles dans le backend).
import { Banknote, ArrowRight, Loader2 } from "lucide-react";
import { useConformiteFetch } from "./useConformiteFetch";

const COLORS = [
  "var(--oh-stat-amber-text)",
  "#10b981",
  "var(--oh-stat-blue-text)",
  "var(--oh-stat-green-text)",
];

export default function ConformitePipelineAvancesWidget() {
  const { data, loading, error } = useConformiteFetch();

  if (loading) {
    return (
      <div
        className="rounded-xl p-5 h-full flex items-center justify-center"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      >
        <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} />
      </div>
    );
  }
  if (error) {
    return (
      <div
        className="rounded-xl p-5"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)", color: "var(--oh-text-muted)" }}
      >
        Erreur Pipeline Avances : {error}
      </div>
    );
  }

  const pipeline = data?.pipeline_avances || [];
  if (!pipeline.length) {
    return (
      <div
        className="rounded-xl p-5 h-full text-center"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)", color: "var(--oh-text-muted)" }}
      >
        Aucune donnée pipeline avances.
      </div>
    );
  }

  const total = pipeline.reduce((s, d) => s + d.count, 0);

  return (
    <div
      className="rounded-xl p-5 h-full"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid="conformite-pipeline-avances-widget"
    >
      <h3 className="font-semibold mb-4 flex items-center gap-2" style={{ color: "var(--oh-text)" }}>
        <Banknote className="w-4 h-4" style={{ color: "var(--oh-stat-amber-text)" }} />
        Pipeline Avances Installateurs
        <span className="text-xs font-normal ml-2" style={{ color: "var(--oh-text-muted)" }}>
          {total} dossiers concernés
        </span>
      </h3>
      <div className="flex items-center gap-2 overflow-x-auto">
        {pipeline.map((step, i) => (
          <div key={step.statut} className="flex items-center gap-2 flex-1 min-w-[120px]">
            <div className="flex flex-col items-center flex-1">
              <div
                className="rounded-lg px-4 py-3 text-center w-full"
                style={{ background: `${COLORS[i]}15`, border: `1px solid ${COLORS[i]}40` }}
              >
                <p className="text-2xl font-bold" style={{ color: COLORS[i] }}>{step.count}</p>
                <p className="text-xs mt-1" style={{ color: "var(--oh-text-secondary)" }}>{step.statut}</p>
              </div>
            </div>
            {i < pipeline.length - 1 && (
              <ArrowRight className="w-5 h-5 flex-shrink-0" style={{ color: "var(--oh-text-muted)" }} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
